<template>
  <v-btn
    small
    rounded
    color="info"
    @click="setNextStep()"
    class="mr-2"
    v-if="step < screens[screens.length - 1]"
    >Continuar</v-btn
  >
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {  
  computed: mapState("atestado", ["step", "screens"]),
  methods: mapMutations("atestado", ["setNextStep"]),
};
</script>

<style>
</style>